<template>
  <div class="wscn-http404">
    <div class="bullshit">
      <img :src="img_404" alt="404">
      <div class="bullshit__headline">你没有相应的管理后台权限，请联系数据产品部</div>
    </div>
  </div>
</template>

<script>
import img_404 from "@/assets/404_images/404.png";

export default {
  data() {
    return {
      img_404
    };
  }
};
</script>

<style lang="less" scoped>
.wscn-http404 {
  position: relative;
  width: 100%;
  .bullshit {
    position: relative;
    width: 300px;
    margin: 0 auto;
    text-align: center;
    top: 360px;
    img{
      width: 121px;
      height: 121px;
      opacity: 0;
      animation-name: slideUpImg;
      animation-duration: 0.5s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }
    &__headline {
      line-height: 24px;
      color: #BEBEBE;
      opacity: 0;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }
    @keyframes slideUp {
      0% {
        transform: translateY(-30px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
    @keyframes slideUpImg {
      0% {
        transform: translateX(60px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
  }
}
</style>
